
import { Component, Prop, Vue } from "nuxt-property-decorator";
import { OilRequirements } from "~/types/OilRequirement";

@Component
export default class PelletsTable extends Vue {
  @Prop() oilRequirements!: OilRequirements;
  energyClasses = ["A+", "A", "B", "C", "D", "E", "F", "G", "H"];
  sizes = [80, 100, 120, 140, 160, 180, 200, 220, 240];

  heizwertMultiplier = 2;

  getRequirement(energyClass, size) {
    return (
      this.oilRequirements[energyClass]?.[size]?.requirement *
      this.heizwertMultiplier
    );
  }

  getPrice(energyClass, size) {
    // divide by 10 because prices are price/1000kg and not price/100kg like heating oil
    return this.oilRequirements[energyClass]?.[size]?.price / 10 ?? "-";
  }
}
